(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quriov-gallery-3d"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGal(sec) {
      if (sec.__q3dReady) return;
      sec.__q3dReady = true;
      var mv = sec.querySelector('[data-q-mv]');
      var poster = sec.querySelector('[data-q-poster]');
      var drag = sec.querySelector('[data-q-drag]');
      var modelsEl = sec.querySelector('[data-q-models]');
      var libSrc = sec.getAttribute('data-lib-src');
      if (!mv) return;
      var models = {};
      try { models = JSON.parse(modelsEl.textContent); } catch (e) {}

      // Respect reduced-motion: no idle auto-spin.
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        mv.removeAttribute('auto-rotate');
      }

      var libLoaded = false;
      function loadLib() {
        if (libLoaded || !libSrc) return;
        libLoaded = true;
        var inject = function () {
          var s = document.createElement('script');
          s.type = 'module';
          s.src = libSrc;
          document.head.appendChild(s);
        };
        // Defer the ~1MB library to idle time so it never competes with hero LCP.
        if ('requestIdleCallback' in window) { requestIdleCallback(inject, { timeout: 2000 }); }
        else { setTimeout(inject, 300); }
      }
      // Lazy-load the model-viewer library only as the gallery nears the viewport — keeps it off hero LCP.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) { if (en.isIntersecting) { loadLib(); io.disconnect(); } });
        }, { rootMargin: '600px 0px' });
        io.observe(sec);
      } else {
        loadLib();
      }

      // Reveal the live model once it has loaded; cross-fade out the poster.
      mv.addEventListener('load', function () {
        mv.classList.add('is-ready');
        if (poster) poster.classList.add('is-hidden');
        if (drag) { drag.classList.add('is-on'); setTimeout(function () { drag.classList.remove('is-on'); }, 3200); }
      });

      // Color switch: swap GLB + poster on the hero's quriov:color event.
      document.addEventListener('quriov:color', function (e) {
        var c = e.detail && e.detail.color;
        if (!c || !models[c]) return;
        if (poster) { poster.src = models[c].poster; poster.classList.remove('is-hidden'); }
        mv.classList.remove('is-ready');
        mv.setAttribute('src', models[c].glb);
      });
    }
    function run() { document.querySelectorAll('[data-q-gallery3d]').forEach(initGal); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quriov-product-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(g) {
      if (g.__qGalReady) return;
      g.__qGalReady = true;
      var strips = g.querySelectorAll('[data-q-gal-color]');
      if (strips.length < 2) return;
      function show(color) {
        var matched = false;
        strips.forEach(function (s) {
          var on = s.getAttribute('data-q-gal-color') === color;
          s.hidden = !on;
          if (on) matched = true;
        });
        return matched;
      }
      document.addEventListener('quriov:color', function (e) {
        if (e.detail && e.detail.color) show(e.detail.color);
      });
    }
    function run() { document.querySelectorAll('[data-q-gallery]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quriov-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBuy(root) {
      if (root.__qBuyReady) return;
      root.__qBuyReady = true;
      var dataEl = root.querySelector('[data-q-variants]');
      if (!dataEl) return;
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var idInput = root.querySelector('[ref="variantId"]');
      var priceEl = root.querySelector('[data-q-price]');
      var cmpEl = root.querySelector('[data-q-compare]');
      var saveEl = root.querySelector('[data-q-save]');
      var atc = root.querySelector('[ref="addToCartButton"]');
      var imgs = root.querySelectorAll('[data-q-img-color]');
      var colorLabel = root.querySelector('[data-q-opt-current="1"]');
      var sel = { 1: null, 2: null };
      root.querySelectorAll('.q-pill[aria-checked="true"]').forEach(function (p) {
        sel[p.getAttribute('data-q-pill-pos')] = p.getAttribute('data-q-pill-val');
      });

      function swapImage(color) {
        imgs.forEach(function (im) {
          var on = im.getAttribute('data-q-img-color') === color;
          if (on === !im.hidden) return;
          if (on) { im.hidden = false; requestAnimationFrame(function () { im.classList.remove('is-fading'); }); }
          else { im.classList.add('is-fading'); setTimeout(function () { im.hidden = true; }, 400); }
        });
      }

      function update() {
        var match = variants.find(function (v) { return v.color === sel[1] && v.size === sel[2]; });
        if (match) {
          if (idInput) idInput.value = match.id;
          if (priceEl && match.price_formatted) priceEl.textContent = match.price_formatted;
          if (cmpEl) {
            if (match.compare_at && match.compare_at > match.price) {
              cmpEl.textContent = match.compare_at_formatted; cmpEl.hidden = false;
              if (saveEl) { saveEl.textContent = 'Save ' + Math.round((match.compare_at - match.price) / match.compare_at * 100) + '%'; saveEl.hidden = false; }
            } else {
              cmpEl.hidden = true; if (saveEl) saveEl.hidden = true;
            }
          }
          if (atc) atc.disabled = !match.available;
          try {
            var u = new URL(window.location);
            u.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', u);
          } catch (e) {}
        } else if (atc) {
          atc.disabled = true;
        }
      }

      function select(pill) {
        if (pill.hasAttribute('data-soldout')) return;
        var pos = pill.getAttribute('data-q-pill-pos');
        var val = pill.getAttribute('data-q-pill-val');
        pill.parentElement.querySelectorAll('.q-pill').forEach(function (p) {
          var on = p === pill;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-checked', on ? 'true' : 'false');
          p.tabIndex = on ? 0 : -1;
        });
        sel[pos] = val;
        if (pos === '1') {
          swapImage(val);
          if (colorLabel) colorLabel.textContent = val;
          // tell the color-reactive sections (gallery strip, sticky thumb) which color is live
          document.dispatchEvent(new CustomEvent('quriov:color', { detail: { color: val } }));
        }
        update();
      }

      root.querySelectorAll('.q-pill').forEach(function (pill) {
        pill.addEventListener('click', function () { select(pill); });
      });

      // WAI-ARIA radiogroup: arrow keys move + select within each group (roving tabindex)
      root.querySelectorAll('[role="radiogroup"]').forEach(function (group) {
        group.addEventListener('keydown', function (e) {
          if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
          e.preventDefault();
          var pills = Array.prototype.slice.call(group.querySelectorAll('.q-pill:not([data-soldout])'));
          if (!pills.length) return;
          var cur = pills.indexOf(document.activeElement);
          if (cur === -1) cur = 0;
          var fwd = e.key === 'ArrowRight' || e.key === 'ArrowDown';
          var next = pills[(cur + (fwd ? 1 : pills.length - 1)) % pills.length];
          next.focus();
          select(next);
        });
      });
    }

    function run() { document.querySelectorAll('[data-quriov-buy]').forEach(initBuy); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    document.addEventListener('shopify:section:load', run);

    // Rating: surface the average number (e.g. "4.77 · 71 reviews"). Judge.me's badge
    // ships the value in data-average-rating but only prints the count — inject the number,
    // and re-apply via observer if Judge.me re-renders the badge.
    function fmtRating() {
      var b = document.querySelector('.q-pdh__rating .jdgm-prev-badge');
      if (!b) return;
      var avg = b.getAttribute('data-average-rating');
      var t = b.querySelector('.jdgm-prev-badge__text');
      if (avg && t && t.textContent.indexOf('·') === -1) {
        t.textContent = avg + ' · ' + t.textContent.trim();
      }
    }
    function watchRating() {
      var wrap = document.querySelector('.q-pdh__rating');
      if (!wrap) return;
      fmtRating();
      try { new MutationObserver(fmtRating).observe(wrap, { childList: true, subtree: true, characterData: true }); } catch (e) {}
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', watchRating); } else { watchRating(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quriov-product-lifestyle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Mouse drag-to-scroll (touch devices already pan natively; only enhance mouse).
    function initDrag(s) {
      if (s.__qDrag) return; s.__qDrag = 1;
      var down = false, sx = 0, sl = 0;
      s.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; sx = e.clientX; sl = s.scrollLeft; s.classList.add('is-drag');
        try { s.setPointerCapture(e.pointerId); } catch (_) {}
      });
      s.addEventListener('pointermove', function (e) {
        if (!down) return; s.scrollLeft = sl - (e.clientX - sx);
      });
      function end(e) {
        if (!down) return; down = false; s.classList.remove('is-drag');
        try { s.releasePointerCapture(e.pointerId); } catch (_) {}
      }
      s.addEventListener('pointerup', end);
      s.addEventListener('pointercancel', end);
      s.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
    function run() { document.querySelectorAll('.q-life__scroll').forEach(initDrag); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quriov-product-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // follow the hero color selection — mirror its already-loaded image (no extra download)
    function bind() {
      var img = document.querySelector('[data-q-story-img]');
      if (!img || img.__qBound) return;
      img.__qBound = true;
      document.addEventListener('quriov:color', function (e) {
        if (!e.detail || !e.detail.color) return;
        var heroImg = document.querySelector('[data-quriov-buy] [data-q-img-color="' + e.detail.color + '"]');
        if (heroImg) {
          var s = heroImg.currentSrc || heroImg.src;
          // clear srcset first — it would otherwise override src and keep the old color
          if (s) { img.srcset = ''; img.src = s; }
        }
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bind); } else { bind(); }
    document.addEventListener('shopify:section:load', bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quriov-sticky-buy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(bar) {
      if (bar.__qReady) return;
      bar.__qReady = true;
      var mainAtc = document.querySelector('[data-quriov-buy] [ref="addToCartButton"]');
      var anchor = document.querySelector('[data-quriov-buy] product-form-component') || document.querySelector('[data-quriov-buy]');
      var stickyPrice = bar.querySelector('[data-q-sticky-price]');
      var mainPrice = document.querySelector('[data-quriov-buy] [data-q-price]');
      if (!mainAtc || !anchor) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          // show the bar once the buy module is scrolled above the viewport
          var below = e.boundingClientRect.top > 0;
          bar.classList.toggle('is-shown', !e.isIntersecting && !below);
        });
      }, { rootMargin: '0px 0px -40% 0px' });
      io.observe(anchor);

      var addBtn = bar.querySelector('[data-q-sticky-add]');
      if (addBtn) addBtn.addEventListener('click', function () {
        mainAtc.dataset.puppet = 'true';
        mainAtc.click();
        delete mainAtc.dataset.puppet;
      });

      // Buy now: add the hero's currently-selected variant, then go straight to checkout
      // (skips the cart). No second product form / no Shop Pay iframe to puppet — reliable.
      var buyBtn = bar.querySelector('[data-q-sticky-buy]');
      var variantInput = document.querySelector('[data-quriov-buy] [ref="variantId"]');
      var addUrl = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
      if (buyBtn && variantInput) buyBtn.addEventListener('click', function () {
        if (buyBtn.getAttribute('aria-busy') === 'true') return;
        var id = variantInput.value;
        if (!id) { mainAtc.click(); return; }
        buyBtn.setAttribute('aria-busy', 'true');
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        }).catch(function () {
          // fall back to the normal add-to-cart flow so the tap is never a dead end
          buyBtn.removeAttribute('aria-busy');
          mainAtc.dataset.puppet = 'true';
          mainAtc.click();
          delete mainAtc.dataset.puppet;
        });
      });

      // keep sticky price in sync if the main price changes
      if (stickyPrice && mainPrice) {
        new MutationObserver(function () { stickyPrice.textContent = mainPrice.textContent; })
          .observe(mainPrice, { childList: true, characterData: true, subtree: true });
      }

      // keep the sticky compare-at (strikethrough) in sync with the hero — value + show/hide
      var mainCompare = document.querySelector('[data-quriov-buy] [data-q-compare]');
      var stickyWas = bar.querySelector('[data-q-sticky-was]');
      if (stickyWas && mainCompare) {
        var syncWas = function () { stickyWas.textContent = mainCompare.textContent; stickyWas.hidden = mainCompare.hidden; };
        syncWas();
        new MutationObserver(syncWas).observe(mainCompare, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      }

      // keep the thumbnail in sync with the selected color (mirror the hero's active image,
      // which is already loaded for that color, so no extra download)
      var thumb = bar.querySelector('[data-q-sticky-thumb]');
      if (thumb) document.addEventListener('quriov:color', function (e) {
        if (!e.detail || !e.detail.color) return;
        var heroImg = document.querySelector('[data-quriov-buy] [data-q-img-color="' + e.detail.color + '"]');
        if (heroImg) { var s = heroImg.currentSrc || heroImg.src; if (s) thumb.src = s; }
      });
    }
    function run() { document.querySelectorAll('[data-q-sticky]').forEach(init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
